<div
  class="add-box"
  id="block-menu"
  [style.display]="contentBoxShow && isContentBoxOpened ? 'block' : 'none'"
  >
  <ul>
    <li class="add-box-title">Add Content</li>
    <li class="add-box-description">Drag a content element to the page.</li>
    <li
      class="editor-block ui-draggable ui-draggable-handle"
      [dndDraggable]="draggableWithDragText"
      (dndStart)="onDragStart($event)"
      (dndEnd)="onDragEnd($event)"
      (dndMoved)="onDragMoved($event)"
      (dndDrag)="onDrag($event)"
      >
      <span class="editor-content-block">
        <span class="material-icons material-content-icons"> description </span>
      </span>
      Text
    </li>
    <li
      class="editor-block ui-draggable ui-draggable-handle"
      [dndDraggable]="draggableWithDragTab"
      (dndStart)="onDragStart($event)"
      (dndEnd)="onDragEnd($event)"
      (dndMoved)="onDragMoved($event)"
      (dndDrag)="onDrag($event)"
      >
      <span class="editor-content-block">
        <span class="material-icons material-content-icons"> tab </span>
      </span>
      Tabs
    </li>
    <li
      class="editor-block ui-draggable ui-draggable-handle"
      [dndDraggable]="draggableWithDragImage"
      (dndStart)="onDragStart($event)"
      (dndEnd)="onDragEnd($event)"
      (dndMoved)="onDragMoved($event)"
      (dndDrag)="onDrag($event)"
      >
      <span class="editor-content-block">
        <span class="material-icons material-content-icons">
          insert_photo
        </span>
      </span>
      Image
    </li>
    <li
      class="editor-block ui-draggable ui-draggable-handle challenge-padding"
      [dndDraggable]="draggableWithDragChallenge"
      (dndStart)="onDragStart($event)"
      (dndEnd)="onDragEnd($event)"
      (dndMoved)="onDragMoved($event)"
      (dndDrag)="onDrag($event)"
      >
      <span class="editor-content-block">
        <span class="material-icons material-content-icons">
          assignment_ind
        </span>
      </span>
      Link to Challenge
    </li>
    <li
      class="editor-block ui-draggable ui-draggable-handle"
      [dndDraggable]="draggableWithDragVideo"
      (dndStart)="onDragStart($event)"
      (dndEnd)="onDragEnd($event)"
      (dndMoved)="onDragMoved($event)"
      (dndDrag)="onDrag($event)"
      >
      <span class="editor-content-block">
        <span class="material-icons material-content-icons">
          video_library
        </span>
      </span>
      Video
    </li>
    <li
      class="editor-block ui-draggable ui-draggable-handle"
      [dndDraggable]="draggableWithDragAudio"
      (dndStart)="onDragStart($event)"
      (dndEnd)="onDragEnd($event)"
      (dndMoved)="onDragMoved($event)"
      (dndDrag)="onDrag($event)"
      >
      <span class="editor-content-block">
        <span class="material-icons material-content-icons"> volume_up </span>
      </span>
      Audio
    </li>

    @if (isCopyPasteContentExist.isCopyExist) {
      <li
        class="editor-block ui-draggable ui-draggable-handle"
        [dndDraggable]="draggableWithDragCopyPaste"
        (dndStart)="onDragStart($event, true)"
        (dndEnd)="onDragEnd($event)"
        (dndMoved)="onDragMoved($event)"
        (dndDrag)="onDrag($event, true)"
        >
        <span class="editor-content-block">
          <span class="material-icons material-content-icons">
            content_paste
          </span>
        </span>
        {{ isCopyPasteContentExist.rowCopied ? "Paste Row" : "Paste" }}
      </li>
    }
  </ul>
</div>

<nav appSwipeout class="head" (click)="clearSelectedEditor(false)">
  <div class="left">
    @if (container.parentContainerId == null) {
      <a
        href="javascript:void(0)"
        style="color: inherit"
        class="close-container-{{ container.id }}"
        (click)="setContainer(null, false)"
        placement="bottom"
        container="body"
        tooltip="Close"
        >
        <span class="icon ic-left-angle"
          ><i class="material-icons">chevron_left</i></span
          >
        </a>
      }
      @if (container.parentContainerId > 0) {
        <a
          href="javascript:void(0)"
          style="color: inherit"
          class="close-container-{{ container.id }}"
          (click)="setContainer(container.parentContainerId, true)"
          placement="bottom"
          container="body"
          tooltip="Close"
          >
          <span class="icon ic-left-angle"
            ><i class="material-icons">chevron_left</i></span
            >
          </a>
        }
        <a class="title" href="javascript:void(0)" (click)="scrollToTop(null)">
          <span
            >{{ container.title }}
            {{ isCurrentPageInDraftMode ? "(Draft Mode)" : "" }}</span
            ></a
            >
            @if (
              languageId === defaultLanguageId && (!showMobileEditor || !isMobile)
              ) {
              <a
                class="playbook-support-link copy-icon"
                href="javascript:void(0)"
                (click)="copyCurrentPage()"
                placement="bottom"
                container="body"
                tooltip="Copy Page"
                >
                <span><i class="material-icons font-size24"> content_copy </i></span>
              </a>
            }
          </div>
          @if (!showMobileEditor || !isMobile) {
            <div
              class="right"
              style="margin-right: 0"
              >
              <a
                class="playbook-support-link"
                [ngClass]="{ 'skeleton-loader': updatingTextBlock || updatingTab }"
                placement="bottom"
                container="body"
                tooltip="Save"
                >
                <span>
                  <i class="material-icons"> save </i>
                </span>
              </a>
              @if (!templateUrl) {
                <a
                  class="playbook-support-link"
                  [appCopyClipboard]="copyViewerLinkToClipboard()"
                  (copied)="notify($event)"
                  placement="bottom"
                  container="body"
                  tooltip="Copy URL"
                  [hidden]="pageFrom"
                  >
                  <span><i class="material-icons"> link </i></span>
                </a>
              }
              @if (playbookLanguages && playbookLanguages.length > 1 && !templateUrl) {
                <a
                  (click)="openLanguageModal()"
                  class="playbook-support-link"
                  placement="bottom"
                  container="body"
                  tooltip="Manage Languages"
                  [hidden]="pageFrom"
                  >
                  <span><i class="material-icons">language</i></span>
                </a>
              }
              @if (!templateUrl) {
                <a
                  id="expandTag"
                  appFullScreen
                  class="playbook-support-link"
                  [hidden]="pageFrom"
                  >
                  @if (screenfull.isEnabled && !screenfull.isFullscreen) {
                    <span
                      placement="bottom"
                      container="body"
                      tooltip="Expand Playbook"
                      >
                      <i class="material-icons">fullscreen</i>
                    </span>
                  }
                  @if (screenfull.isEnabled && screenfull.isFullscreen) {
                    <span
                      placement="bottom"
                      container="body"
                      tooltip="Collapse Playbook"
                      >
                      <i class="material-icons">fullscreen_exit</i>
                    </span>
                  }
                </a>
              }
              <a
                (click)="toggleDrawer()"
                id="pageSectionAttachedResourceButtonId"
                appSwipeShow
                placement="bottom"
                container="body"
                tooltip="View Attached Resources"
                >
                <span><i class="material-icons">attach_file</i></span>
                <span class="clip-res-count count">{{ resourceCounts }}</span>
              </a>
              @if (!templateUrl) {
                <a
                  (click)="openSupportMail()"
                  [ngStyle]="{ color: isCustomCss ? '' : 'white' }"
                  class="playbook-support-link"
                  placement="bottom"
                  container="body"
                  tooltip="Playbook Support"
                  [hidden]="pageFrom"
                  >
                  <span><i class="material-icons">help_outline</i></span>
                </a>
              }
              <div class="edit-mode-icons">
                @if (languageId === defaultLanguageId) {
                  <a
                    class="edit-icon"
                    id="block-menu-button"
                    (click)="showBlockMenuFunc()"
                    [class.disabled]="showMobileEditor"
                    >
                    <span
                      class="material-icons"
                      [ngClass]="isServerProcess ? 'opacity05' : 'opacity1'"
                      placement="bottom"
                      container="body"
                      tooltip="Add Content"
                      >
                      add
                    </span>
                  </a>
                }
                @if (!showMobileEditor) {
                  <a
                    class="edit-icon"
                    id="block-menu-button"
                    (click)="undoRedoPopUp()"
                    >
                    <span
                      class="material-icons"
                      [ngClass]="isServerProcess ? 'opacity05' : 'opacity1'"
                      placement="bottom"
                      container="body"
                      tooltip="Undo/Redo"
                      >
                      undo
                    </span>
                  </a>
                }
                @if (languageId === defaultLanguageId) {
                  <a
                    class="edit-icon"
                    (click)="openApplyTemplateModal()"
                    >
                    <span
                      class="material-icons"
                      placement="bottom"
                      container="body"
                      tooltip="Choose a Page Template"
                      >
                      table_chart
                    </span>
                  </a>
                }
                @if (languageId === defaultLanguageId && !templateUrl) {
                  <a
                    class="edit-icon"
                    (click)="openCopyTemplateModal()"
                    id="pageSectionCopyTemplateButtonId"
                    [hidden]="pageFrom"
                    >
                    <span
                      class="material-icons"
                      placement="bottom"
                      container="body"
                      tooltip="Copy Page as Template"
                      >
                      file_copy
                    </span>
                  </a>
                }
                @if (
                  loggedInProfile.role !== profileRolesEnum.administrator &&
                  !templateUrl
                  ) {
                  <a
                    class="edit-icon"
                    (click)="openPlaybookCssModal()"
                    [hidden]="pageFrom"
                    >
                    <span
                      class="material-icons"
                      placement="bottom"
                      container="body"
                      tooltip="Edit vPlaybook CSS"
                      >
                      palette
                    </span>
                  </a>
                }
                @if (
                  isCurrentPageInDraftMode &&
                  languageId === defaultLanguageId &&
                  !templateUrl
                  ) {
                  <a
                    class="edit-icon"
                    >
                    <span
                      class="material-icons"
                      (click)="openDraftModal()"
                      placement="bottom"
                      container="body"
                      tooltip="Apply Draft Changes"
                      >
                      check_circle_outline
                    </span>
                  </a>
                }
              </div>
              @if (templateUrl || pageFrom) {
                <a
                  (click)="openSupportMail()"
                  [ngStyle]="{ color: isCustomCss ? '' : 'white' }"
                  class="playbook-support-link me-2"
                  placement="bottom"
                  container="body"
                  tooltip="Playbook Support"
                  >
                  <span><i class="material-icons">help_outline</i></span>
                </a>
              }
              @if (!templateUrl) {
                <a
                  id="sectionListStartEditingGearIconId"
                  (click)="redirectToViewer()"
                  placement="bottom"
                  container="body"
                  tooltip="Done Editing"
                  [hidden]="pageFrom"
                  >
                  <span><i class="material-icons">settings</i></span>
                  <span style="margin-right: 10px">Done</span>
                </a>
              }
            </div>
          }
        </nav>
        <nav
          appSwipeout
          id="side-nav-{{ container.id }}"
          class="side side-nav"
          (click)="clearSelectedEditor(true)"
          [ngStyle]="showMobileEditor && { 'border-right': '0' } && { width: '0' }"
          >
          @if (!showMobileEditor) {
            <div class="scroll-cont">
              <div class="side-cont">
                <div
                  id="side-cont-box-{{ container.id }}"
                  class="side-cont-box sidebar-scroll"
                  >
                  <div class="sections">
                    @if (
                      (checkForDisplayDraft(container) === 1 ? true : false) &&
                      languageId == defaultLanguageId &&
                      !templateUrl
                      ) {
                      <a
                        (click)="createDraftMode(container)"
                        class="add-container"
                        id=""
                        >Create Draft<span class="icon ic-add"></span
                      ></a>
                    }
                    @if (
                      (checkForDisplayDraft(container) == 2 ? true : false) &&
                      !templateUrl
                      ) {
                      <a
                        (click)="viewActiveDraft(container)"
                        class="add-container"
                        id=""
                        >View Active Draft</a
                        >
                      }
                      @if (isCurrentPageInDraftMode && !templateUrl) {
                        <a
                          (click)="leaveDraftMode(container)"
                          class="add-container"
                          id=""
                          style="margin-bottom: 10px"
                          >Leave Draft Mode<span class="icon ic-close"></span
                        ></a>
                      }
                      @if (
                        !container.isCurrentPageInDraftMode && list.sections.length > 0
                        ) {
                        <ul
                          cdkDropList
                          (cdkDropListDropped)="onSectionItemDrop($event)"
                          class="section-containers"
                          >
                          @for (cont of list.sections | orderBy : 'orderBy'; track cont) {
                            <li
                              id="section-{{ cont.id }}"
                              cdkDrag
              [hidden]="
                cont.title == undefined &&
                cont.title == null &&
                cont.title == ''
              "
                              [cdkDragDisabled]="languageId !== defaultLanguageId"
                              >
                              <a
                                id="section-link-{{ cont.id }}"
                                [class.current]="cont.on"
                                (click)="showSection(cont)"
                                >{{ cont.title }}</a
                                >
                                <a
                                  class="edit"
                                  style="z-index: 1333"
                                  (click)="editContainer(cont)"
                                  placement="bottom"
                                  container="body"
                                  tooltip="Edit Item"
                                  >
                                  <i class="material-icons md-18">create</i>
                                </a>
                                @if (languageId === defaultLanguageId) {
                                  <a
                                    style="z-index: 1333"
                                    class="reorder"
                                    placement="bottom"
                                    container="body"
                                    tooltip="Reorder Item"
                                    >
                                    <i class="material-icons md-18">open_with</i>
                                  </a>
                                }
                              </li>
                            }
                          </ul>
                        }
                        @if (
                          container.isCurrentPageInDraftMode && list.draftSection.length > 0
                          ) {
                          <ul
                            cdkDropList
                            (cdkDropListDropped)="onSectionItemDrop($event)"
                            class="section-containers"
                            >
                            @for (cont of list.draftSection | orderBy : 'orderBy'; track cont) {
                              <li
                                id="section-{{ cont.id }}"
                                cdkDrag
              [hidden]="
                cont.title == undefined &&
                cont.title == null &&
                cont.title == ''
              "
                                [cdkDragDisabled]="languageId !== defaultLanguageId"
                                >
                                <a
                                  id="section-link-{{ cont.id }}"
                                  [class.current]="cont.on"
                                  (click)="showSection(cont)"
                                  >{{ cont.title }}</a
                                  >
                                  <a
                                    class="edit"
                                    style="z-index: 1333"
                                    (click)="editContainer(cont)"
                                    placement="bottom"
                                    container="body"
                                    tooltip="Edit Item"
                                    >
                                    <i class="material-icons md-18">create</i>
                                  </a>
                                  @if (languageId === defaultLanguageId) {
                                    <a
                                      style="z-index: 1333"
                                      class="reorder"
                                      placement="bottom"
                                      container="body"
                                      tooltip="Reorder Item"
                                      >
                                      <i class="material-icons md-18">open_with</i>
                                    </a>
                                  }
                                </li>
                              }
                            </ul>
                          }
                          @if (languageId === defaultLanguageId) {
                            <a
                              (click)="addSection()"
                              class="add-container"
                              >Add Section
                              <i class="material-icons md-18">add_circle_outline</i></a
                              >
                            }
                          </div>
                          @if (!container.isCurrentPageInDraftMode && list.pages.length > 0) {
                            <div
                              class="pages"
                              >
                              <ul
                                cdkDropList
                                (cdkDropListDropped)="onContainerItemDrop($event)"
                                class="page-containers"
                                >
                                @for (cont of list.pages | orderBy : 'orderBy'; track cont) {
                                  <li
                                    cdkDrag
                                    id="page-{{ cont.id }}"
                                    [cdkDragDisabled]="languageId !== defaultLanguageId"
                                    >
                                    <a
                                      (click)="setContainer(cont.id, false)"
                                      [ngClass]="{ current: cont.on == true }"
                                      >{{ cont.title }}</a
                                      >
                                      <a
                                        class="edit"
                                        style="z-index: 1333"
                                        (click)="editContainer(cont)"
                                        placement="bottom"
                                        container="body"
                                        tooltip="Edit Item"
                                        >
                                        <i class="material-icons md-18">create</i>
                                      </a>
                                      @if (languageId === defaultLanguageId) {
                                        <a
                                          style="z-index: 1333"
                                          class="reorder"
                                          placement="bottom"
                                          container="body"
                                          tooltip="Reorder Item"
                                          >
                                          <i class="material-icons md-18">open_with</i>
                                        </a>
                                      }
                                    </li>
                                  }
                                </ul>
                              </div>
                            }
                            @if (
                              container.isCurrentPageInDraftMode && list.draftPages.length > 0
                              ) {
                              <div
                                class="pages"
                                >
                                <ul
                                  cdkDropList
                                  (cdkDropListDropped)="onContainerItemDrop($event)"
                                  class="page-containers"
                                  >
                                  @for (cont of list.draftPages | orderBy : 'orderBy'; track cont) {
                                    <li
                                      cdkDrag
                                      id="page-{{ cont.id }}"
                                      [cdkDragDisabled]="languageId !== defaultLanguageId"
                                      >
                                      <a
                                        (click)="setContainer(cont.id, false)"
                                        [ngClass]="{ current: cont.on == true }"
                                        >{{ cont.title }}</a
                                        >
                                        <a
                                          class="edit"
                                          style="z-index: 1333"
                                          (click)="editContainer(cont)"
                                          placement="bottom"
                                          container="body"
                                          tooltip="Edit Item"
                                          >
                                          <i class="material-icons md-18">create</i>
                                        </a>
                                        @if (languageId === defaultLanguageId) {
                                          <a
                                            style="z-index: 1333"
                                            class="reorder"
                                            placement="bottom"
                                            container="body"
                                            tooltip="Reorder Item"
                                            >
                                            <i class="material-icons md-18">open_with</i>
                                          </a>
                                        }
                                      </li>
                                    }
                                  </ul>
                                </div>
                              }
                              @if (languageId === defaultLanguageId) {
                                <a
                                  (click)="addNewPage()"
                                  class="add-container"
                                  >Add Page <i class="material-icons md-18">add_circle_outline</i></a
                                  >
                                }
                              </div>
                            </div>
                          </div>
                        }
                      </nav>
                      @if (container.on && !showMobileEditor) {
                        <article
                          #contentBox
                          class="content"
                          id="content-{{ container.id }}"
                          [ngStyle]="inMobileEditor && { 'overflow-y': 'hidden' }"
                          (click)="clearSelectedEditor(true); ($event.stopPropagation)"
                          >
                          <app-container-content
                            [Container]="container"
                            [isDraftMode]="isCurrentPageInDraftMode"
                            (tabChange)="changeTabFunc($event)"
                            (ratingModalOpen)="openRatingModalFunc()"
                            [videoListPerSection]="videoListPerSection"
                            >
                          </app-container-content>
                        </article>
                      }

                      @for (cont of container.containers | filterBy : { type: 1 }; track cont) {
                        @if (cont.on) {
                          <app-container
                            class="card page-card"
                            [playbookId]="playbookId"
                            [containers]="cont"
                            [companyId]="companyId"
                            [isCustomCss]="isCustomCss"
                            [isParentPageInDraftMode]="isCurrentPageInDraftMode"
                            >
                          </app-container>
                        }
                      }
